// extracted by mini-css-extract-plugin
module.exports = {"loader":"MappingSlide_loader__1-qf6","text":"MappingSlide_text__3sqMR","link":"MappingSlide_link__1AeP9"};